define('modules/common/service/ListaFascicoli',[], function() {
	var ListaFascicoli = function($http, $q, PATH, Token, Studio, LoadingHandler) {

		var paginazione;
		var sortby;
		var sortdirection;
		var progressivo = 1;
		var testo;

		var lista = false;
		var navigazione = false;

		var preparaParams = function() {
			var params = {};
			params.progressivo = progressivo;

			if (paginazione) {
				params.paginazione = paginazione;
			}

			if (sortby) {
				params.sortby = sortby;
			}

			if (sortdirection) {
				params.sort = sortdirection;
			}

			if (testo) {
				params.testo = testo;
			}

			return params;
		};

		var load = function() {
			$http.defaults.headers.common['Authorization'] = 'TOKEN:' + Token.get();
			var deferred = $q.defer();

			LoadingHandler.start();

			Studio.getId().then(function(id) {
				$http({
					method: 'GET',
					url: 'https://' + PATH.ENTRYPOINT + '/' + id + '/fascicoli/lista',
					cache: false,
					params: preparaParams()
				}).then(
					function(response) {
						lista = response.data.fascicolo;
						navigazione = response.data.navigazione;
						deferred.resolve();
						LoadingHandler.stop();
					},
					function(error) {
						deferred.reject({
							status: error.status,
							data: error.data
						});
						LoadingHandler.stop();
					});
			}, function(error) {
				deferred.reject({
					status: error.status,
					data: error.data
				});
				LoadingHandler.stop();
			});

			return deferred.promise;

		};

		var reset = function() {
			lista = false;
			navigazione = false;
			progressivo = 1;
		};

		var execAfterContentIsLoaded = function() {
			var deferred = $q.defer();
			if (lista) {
				deferred.resolve();
			} else {
				load().then(function() {
					deferred.resolve();
				}, function(error) {
					deferred.reject(error);
				});
			}
			return deferred.promise;
		};

		return {
			setQuery: function(query) {
				testo = query;
			},
			getQuery: function() {
				return testo;
			},
			setPaginazione: function(pag) {
				paginazione = pag;
			},
			getPaginazione: function() {
				return paginazione;
			},
			setSort: function(campo, verso) {
				sortby = campo;
				sortdirection = verso;
				reset();
			},
			load: load,
			reset: reset,
			get: function() {
				return execAfterContentIsLoaded().then(function() {
					return lista;
				});
			},
			getNext: function() {
				var oldProg = progressivo;
				reset();
				progressivo = oldProg + paginazione;
				return execAfterContentIsLoaded().then(function() {
					return lista;
				});
			},
			canGetNext: function() {
				return (navigazione.trovati > (progressivo + paginazione));
			}
		};
	};

	return ["$http", "$q", "PATH", "Token", "Studio", "LoadingHandler", ListaFascicoli];
});
